import { ThemeProvider } from "@mui/material";
import { ApiQueries, daymapTheme, useSchool } from "daymap-react";
import { useMemo } from "react";



export const DaymapThemeProvider: React.FC<{children: React.ReactNode, LinkBehavior?:any}> = ({children, LinkBehavior}) => {
    const {schoolCode} = useSchool();
    const {data} = new ApiQueries.settings.DaymapTheme(schoolCode).ToQuery();

    const theme = useMemo(
        () => daymapTheme({LinkBehavior, Colour:data?.themePrimary, GenerateCss:true})
        ,[data, schoolCode]
    )

    return (
        <ThemeProvider theme={theme}>
            {children}
        </ThemeProvider>
    )
}

